export default {
  getAssessmentInfoByID: (state) => (careworkerID) => {
    return state.assessmentInfos.filter(assessmentInfo => assessmentInfo.careworkerID === careworkerID)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/assessmentInfoModules/getters.js